<template>
    <div class="about">
        <div id="page-title-area" class="main_visual">
            <div id="page-title-box">
                <h1>Achievement</h1>
                <p>施工実績</p>
                <div class="title-sq"></div>
            </div>
        </div>

        <div class="table-display-area">
            <table class="upAnime">
                <tr>
                    <th>発注者</th>
                    <th>工事名</th>
                    <th>工事種別</th>
                    <th>現場所在地</th>
                </tr>
                <tr>
                    <td>発注者</td>
                    <td>布土小学校体育館改修工事</td>
                    <td>鳶工</td>
                    <td>愛知県知多郡</td>
                </tr>
                <tr>
                    <td>発注者</td>
                    <td>河和南部小学校体育館改修工事</td>
                    <td>鳶工</td>
                    <td>愛知県知多郡</td>
                </tr>
                <tr>
                    <td>発注者</td>
                    <td>日本福祉大学半田キャンパス渡り廊下改修工事</td>
                    <td>鳶工</td>
                    <td>愛知県知多郡</td>
                </tr>
                <tr>
                    <td>発注者</td>
                    <td>名港海運飛島倉庫改修工事</td>
                    <td>鳶工</td>
                    <td>愛知県名古屋市</td>
                </tr>
            </table>
        </div>

        <div class="table-display-area-border upAnime"></div>

        <p id="now-roading" class="fadeAnime">※その他にも公開可能な実績を現在準備中です。</p>
    </div>
</template>

<script>
    export default {
        name: "Achievement",
        title: '施工実績',
    }
</script>

<style scoped>
    @import "../assets/css/achievement.css";
</style>
